import React from "react";

function OptionSelector({
  title,
  options,
  value,
  onChange,
  customValue,
  onCustomChange,
}) {
  const selectedOption = options.find(
    (option) => option.value === value
  );

  return (
    <div className="option-selector">
      <h3>{title}</h3>

      <div className="option-list">
        {options.map((option) => (
          <label
            key={option.value}
            className={`option ${
              value === option.value ? "selected" : ""
            }`}
          >
            <input
              type="radio"
              name={title}
              value={option.value}
              checked={value === option.value}
              onChange={(event) => onChange(event.target.value)}
            />

            <span>{option.label}</span>

            {option.price > 0 && (
              <span className="option-price">
                +${option.price}
              </span>
            )}
          </label>
        ))}
      </div>

      {selectedOption?.value === "custom" && (
        <input
          type="text"
          value={customValue}
          onChange={(event) => onCustomChange(event.target.value)}
          placeholder="Enter custom color"
          className="custom-color-input"
        />
      )}
    </div>
  );
}

export default OptionSelector;